export default "__VITE_ASSET__BJ5V22PX__"